import React, { useState, useEffect, useCallback, useRef } from "react";
import { createPortal } from "react-dom";
import "../report/report.scss";
import axios from "axios";
import urls from "../../utils/url";
import { isGraphPlaceId } from "../../utils/graphPlaceIds";
import NewPatientReportToolbar from "./NewPatientReportToolbar";
import { connect } from "react-redux";
import { addPatientDetail } from "../../redux/features/details/patientDetail";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import Collapse from "@mui/material/Collapse";
import LocalDatePicker from "../../components/common/datepicker";
import Filter from "../../components/common/filter";
import { useNavigate } from "react-router-dom";
import {
  limitStr,
  getReadableTime,
  getReferralDetails,
  isJson,
  TooltipComponent,
  getChildStatusString,
  getReadableDateOnly,
} from "../../utils/converter";
import { medicalData } from "../../utils/sheetConstants";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "../../components/common/loading";
import InputLabel from "@mui/material/InputLabel";
import Reload from "../../components/common/Reload";
import PartographLayout from "../../components/partograph/partograph";
import fieldMap from "../../utils/fieldMap";
import { downloadReport } from "../../utils/excelSheet";
import { IconButton } from "@mui/material";
import Cookie from "js-cookie";
import Chip from "@mui/material/Chip";
import CardAlerts from "../../components/common/cardAlerts";
import analytics from "../analytics/analytics";
import dayjs from "dayjs";
import useAutoRefresh from "../../hooks/useAutoRefresh";

// You can adjust the styles by using the `styled` function
const StyledInputLabel = styled(InputLabel)({
  //color: '#171717',
  fontSize: "1rem",
  fontWeight: "500",
  marginTop: "1.25rem",
  marginBottom: "0.625rem",
  fontFamily: "Poppins",
});

const StyledSelect = styled(Select)({
  "& .MuiPaper-root": {
    backgroundColor: "#faf6ff", // This will change the background color of the dropdown
  },
  borderRadius: "4px",
  border: "0.5px solid #BFBFBF",
  background: "#fff",
  width: "9.375rem", // You can adjust the width as needed
  "& .MuiSelect-select": {
    //background: '#faf6ff',
    height: "0.625rem", // This might be too small, adjust as needed
    padding: "0.625rem",
  },
});

const StyledMenuItem = styled(MenuItem)({
  fontFamily: "Poppins !important",
  "&:hover": {
    backgroundColor: "#faf6ff",
  },
  "&.Mui-selected": {
    backgroundColor: "#faf6ff",
    "&:hover": {
      backgroundColor: "#faf6ff", // to maintain the same color on hover for a selected item
    },
  },
});

const StyledChip = styled(Chip)({
  borderRadius: "500px",
  border: "1px solid #C7C7C7",
  background: "#F8F3FF",
  height: "1.875rem",
  flexShrink: 0,
  fontFamily: "Poppins",
  fontSize: "1rem",
  fontStyle: "normal",
  fontWeight: 300,
  textTransform: "capitalize",
  color: "#707070",
});

const StyleChip = styled(Chip)({
  borderRadius: "500px",
  border: "1px solid #C7C7C7",
  background: "#fff",
  height: "1.875rem",
  flexShrink: 0,
  fontFamily: "Poppins",
  fontSize: "1rem",
  fontStyle: "normal",
  fontWeight: 300,
  textTransform: "capitalize",
  color: "#707070",
});

const Report = ({ isMrn, onDataRefresh }) => {
  // isMrn: For Malaysia Specific Requirement

  //// console.log(isMrn)
  const FILTER_KEY = "report_filters";
    const savedFilters = (() => {
  try { return JSON.parse(sessionStorage.getItem(FILTER_KEY)) || {}; } 
  catch { return {}; }
})();

  const cookie = Cookie.get("access_token");
  const navigate = useNavigate();

  // Gated place IDs get the new Figma search/filter UI; everyone else keeps
  // the existing report page unchanged. See src/utils/graphPlaceIds.js.
  const hospitalDetailCookie = (() => {
    try {
      return JSON.parse(Cookie.get("hospital_detail") || "{}");
    } catch {
      return {};
    }
  })();
  const isNewUIPlace = isGraphPlaceId(hospitalDetailCookie?.hospitalID);

  // dashboard.jsx renders an empty #report-search-slot in its shared header
  // (left of the hospital logo) that this page portals its search bar into
  // when gated — the slot only exists once Dashboard has committed to the
  // DOM, so it's picked up in an effect rather than read during render.
  const [searchPortalTarget, setSearchPortalTarget] = useState(null);
  useEffect(() => {
    if (isNewUIPlace) {
      setSearchPortalTarget(document.getElementById("report-search-slot"));
    }
  }, [isNewUIPlace]);
  const [isExpanded, setIsExpanded] = useState(false);
  const [value1, setValue1] = useState(
  savedFilters.value1 ? dayjs(savedFilters.value1) : undefined
);
  const [value2, setValue2] = useState(
  savedFilters.value2 ? dayjs(savedFilters.value2) : undefined
);
  const [openPartograph, setOpenPartograph] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [placeID, setPlaceID] = useState("");
  const [patientID, setPatientID] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
const [patientTab, setPatientTab] = useState(
  savedFilters.patientTab || "all_patient"
);
  const [startIndex, setStartIndex] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [patients, setPatients] = useState([]);
  let [totalPatient, setTotalPatient] = useState(0);
  const [searchID, setSearchID] = useState("");
  const [isSearch, setIsSearch] = useState(false);
  const [searchPatients, setSearchPatients] = useState([]);
  const [placeDetails, setPlaceDetails] = useState([]); // State to store the data from the backend
  const [searchError, setSearchError] = useState(false);

  const [places, setPlaces] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
 const [isFiltered, setIsFiltered] = useState(
  savedFilters.isFiltered || false
);
  const [fetchTrigger, setFetchTrigger] = useState(false);
  const [accountType, setAccountType] = useState("");
  const [hasFiltersBeenApplied, setHasFiltersBeenApplied] = useState(false);
  const [openEndDateCalender, setOpenEndDateCalender] = useState(false);
  const [showHelper, setShowHelper] = useState(false);
  const [analyticData, setAnalyticData] = useState({});

  const [isAutoRefreshing, setIsAutoRefreshing] = useState(false);
  const syncRefreshTimeRef = useRef(null);

  // Mirrors of fast-changing state, read inside performAutoRefresh's guard.
  // Keeping these out of performAutoRefresh's own dependency array stops its
  // identity (and the refresh timer that depends on it) from being torn down
  // and restarted every time a normal fetch flips `loading`.
  const isSearchRef = useRef(isSearch);
  const errorRef = useRef(error);
  const loadingRef = useRef(loading);
  const isDownloadingRef = useRef(isDownloading);
  const startIndexRef = useRef(startIndex);
  isSearchRef.current = isSearch;
  errorRef.current = error;
  loadingRef.current = loading;
  isDownloadingRef.current = isDownloading;
  startIndexRef.current = startIndex;

  const initialSelectedOptions = {};

  Object.keys(medicalData).forEach((key) => {
    initialSelectedOptions[key] = "";
  });

const [selectedOptions, setSelectedOptions] = useState(
  savedFilters.selectedOptions || initialSelectedOptions
);


  // Bridging state fed by NewPatientReportToolbar's onApply — that component
  // owns all of the new UI's own filter state (Zone/District/Facility, date
  // range) internally and only ever hands back these resolved values.
  // report.jsx never reads/writes the toolbar's internal state directly, so
  // there's no way for it to collide with the legacy filters/selectedOptions/
  // value1/value2 used by the old UI below. newUISelectedOptions has no
  // medical-data filter of its own (not part of the new Figma UI) — it stays
  // fixed at initialSelectedOptions so the existing query-building code below
  // (which always reads selectedOptions.timeline etc.) gets the same benign
  // empty-string fields a legacy user with no medical filters would produce.
  const [newUIPlaceIds, setNewUIPlaceIds] = useState("");
  const [newUIFromValue, setNewUIFromValue] = useState("");
  const [newUIToValue, setNewUIToValue] = useState("");
  const [newUIIsFiltered, setNewUIIsFiltered] = useState(false);
  const newUISelectedOptions = initialSelectedOptions;

  // Only ever called from NewPatientReportToolbar's Apply/Reset — Patient
  // Type, Zone, District, Facility, and Date Range are all staged locally in
  // the toolbar and only take effect here, together, in one go. No filter
  // (patient type included) applies just from changing a dropdown.
  const handleNewUIApply = ({
    placeIds,
    fromValue: applyFromValue,
    toValue: applyToValue,
    isFiltered: applyIsFiltered,
    patientTab: applyPatientTab,
  }) => {
    if (applyPatientTab) setPatientTab(applyPatientTab);
    setNewUIPlaceIds(placeIds);
    setNewUIFromValue(applyFromValue);
    setNewUIToValue(applyToValue);
    setNewUIIsFiltered(applyIsFiltered);
    setPatients([]);
    setTotalPatient(0);
    setStartIndex(0);
    setFetchTrigger((t) => !t);
  };

  const fromValue = value1 ? value1.unix() : "";
  const toValue = value2 ? value2.unix() : "";

  const [availableFilters, setAvailableFilters] = useState({
    State: [],
    District: [],
    Facility: [],
  });

const [filters, setFilters] = useState(
  savedFilters.filters || { State: "All", District: "All", Facility: "All" }
);

  const premuimTabOptions = {
    "All Patients": "all_patient",
    "Intrapartum Tab": "intra_partum_process",
    "Postpartum Tab": "post_partum_process",
    "Completed Tab": "completed",
  };

  const basicTabOptions = {
    "All Patients": "all_patient",
    "Live Patients": "intra_partum_process",
    Completed: "completed",
  };

  const getStartDay = (date) => {
    if (!date?.$d) return null;
    return dayjs(date.$d).startOf("day"); // Sets time to 00:00:00
  };

  const getEndDay = (date) => {
    if (!date?.$d) return null;
    return dayjs(date.$d).endOf("day"); // Same day 11:59:59 pm
  };

  const handleStartDateChange = (newValue) => {
    if (!newValue) return;

    const adjustedStartDate = getStartDay(newValue);
    setValue1(adjustedStartDate);
    setValue2(""); // Reset end date
    setOpenEndDateCalender(true);
    setShowHelper(true);
  };

  const handleEndDateChange = (newValue) => {
    if (!newValue) return;

    const adjustedEndDate = getEndDay(newValue);
    setValue2(adjustedEndDate);
    setOpenEndDateCalender(false);
    setShowHelper(false);
  };

  useEffect(() => {
    const cookieData = Cookie.get("data");
    if (cookieData) {
      const parsedData = JSON.parse(cookieData);
      const account_type = parsedData.account_type;
      setAccountType(account_type);
    }
  }, []);


  const handleSelectChange = async (event, key) => {
    const value = event.target.value === "All" ? "" : event.target.value;

    setSelectedOptions({
      ...selectedOptions,
      [key]: value,
    });
  };

  const handleFilterChange = (filterType, selectedValue) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterType]: selectedValue,
    }));

    updateAvailableFilters(filterType, selectedValue);
  };

    useEffect(() => {
  sessionStorage.setItem(FILTER_KEY, JSON.stringify({
    value1: value1 ? value1.toISOString() : null,
    value2: value2 ? value2.toISOString() : null,
    patientTab,
    filters,
    selectedOptions,
    isFiltered,
  }));
}, [value1, value2, patientTab, filters, selectedOptions, isFiltered]);

  useEffect(() => {
    const active = checkIfFiltersAreActive();
    setIsFiltered(active);
  }, [selectedOptions, filters, fromValue, toValue, patientTab]);

  const checkIfFiltersAreActive = () => {
    const dateFiltered = value1 != null && value2 != null;
    //console.log(dateFiltered, 'date')
    const selectedOptionsFiltered = Object.values(selectedOptions).some(
      (value) => value !== "All" && value !== ""
    );
    //console.log(selectedOptionsFiltered, 'type')
    const filtersFiltered = Object.values(filters).some(
      (value) => value !== "All" && value !== ""
    );
    //console.log(filtersFiltered, 'filters')
    //console.log(dateFiltered || selectedOptionsFiltered || filtersFiltered, 'final')
    return dateFiltered || selectedOptionsFiltered || filtersFiltered;
  };

  const clearSelectedFilters = (categoryToDelete, valueToDelete) => {
    if (categoryToDelete in selectedOptions) {
      setSelectedOptions((prevSelectedOptions) => {
        if (prevSelectedOptions[categoryToDelete] === valueToDelete) {
          const { [categoryToDelete]: removed, ...rest } = prevSelectedOptions;
          return { ...rest, [categoryToDelete]: "" };
        }
        return prevSelectedOptions;
      });
    }

    if (categoryToDelete in filters) {
      setFilters((prevFilters) => {
        if (prevFilters[categoryToDelete] === valueToDelete) {
          const { [categoryToDelete]: removed, ...rest } = prevFilters;
          return { ...rest, [categoryToDelete]: "All" };
        }
        return prevFilters;
      });
    }

    if (categoryToDelete === "dateFilters") {
      setValue1(null);
      setValue2(null);
    }

    const dateFiltered = value1 != null && value2 != null; //changed here || -- &&
    const selectedOptionsFiltered = Object.values(selectedOptions).some(
      (value) => value !== "All" && value !== ""
    );
    const filtersFiltered = Object.values(filters).some(
      (value) => value !== "All" && value !== ""
    );
    setIsFiltered(dateFiltered || selectedOptionsFiltered || filtersFiltered);

    const activeFilters = checkIfFiltersAreActive();
    if (!activeFilters) {
      setHasFiltersBeenApplied(false);
    }

    handleApplyFilters();
  };

  const clearAllFilters = () => {
    sessionStorage.removeItem(FILTER_KEY);
    setSelectedOptions((prevSelectedOptions) => {
      let resetOptions = {};
      Object.keys(prevSelectedOptions).forEach((key) => {
        resetOptions[key] = "";
      });
      return resetOptions;
    });

    // Set all keys in filters to 'All'
    setFilters((prevFilters) => {
      let resetFilters = {};
      Object.keys(prevFilters).forEach((key) => {
        resetFilters[key] = "All";
      });
      return resetFilters;
    });

    setValue1(null);
    setValue2(null);
    setIsFiltered(false);
    handleReload();
  };

  const handleReload = () => {
    window.location.reload();
  };

  const updateAvailableFilters = (changedFilter, selectedValue) => {
    setFilters((prevFilters) => {
      let newFilters = { ...prevFilters };

      if (changedFilter === "State") {
        newFilters = {
          ...newFilters,
          State: selectedValue,
          District: "All",
          Facility: "All",
        };
      } else if (changedFilter === "District") {
        newFilters = {
          ...newFilters,
          District: selectedValue,
          Facility: "All",
        };
      }

      return newFilters;
    });

    setAvailableFilters((prevAvailableFilters) => {
      const newAvailableFilters = { ...prevAvailableFilters };

      if (changedFilter === "State") {
        newAvailableFilters.District = [
          "All",
          ...removeDuplicate(
            placeDetails
              .filter(
                (place) =>
                  selectedValue === "All" || place.state === selectedValue
              )
              .map((place) => place.district)
          ),
        ];
        newAvailableFilters.Facility = ["All"];
      } else if (changedFilter === "District") {
        newAvailableFilters.Facility = [
          "All",
          ...removeDuplicate(
            placeDetails
              .filter(
                (place) =>
                  selectedValue === "All" || place.district === selectedValue
              )
              .map((place) => place.name)
          ),
        ];
      }

      return newAvailableFilters;
    });
  };

  // Initialize available filters when component mounts or when placeDetails change
  useEffect(() => {
    const states = [
      "All",
      ...removeDuplicate(placeDetails.map((place) => place.state)),
    ];

    const districts =
      filters.State === "All"
        ? [
            "All",
            ...removeDuplicate(placeDetails.map((place) => place.district)),
          ]
        : [
            "All",
            ...removeDuplicate(
              placeDetails
                .filter((place) => place.state === filters.State)
                .map((place) => place.district)
            ),
          ];

    const facilities =
      filters.District === "All"
        ? [
            "All",
            ...removeDuplicate(placeDetails.map((place) => place.name)),
          ]
        : [
            "All",
            ...removeDuplicate(
              placeDetails
                .filter((place) => place.district === filters.District) // Restrict to selected district
                .map((place) => place.name)
            ),
          ];

    setAvailableFilters({
      State: states,
      District: districts,
      Facility: facilities,
    });
  }, [placeDetails, filters]);

  const handleTabChange = (e) => {
    setPatientTab(e.target.value);
    setStartIndex(0);
    setSearchID("");
    setPatients([]); // Clear existing patients
    setTotalPatient(0);
    handleApplyFilters();
  };

  const handleExpandClick = () => {
    setSearchID("");
    setIsExpanded(!isExpanded);
  };

  const removeDuplicate = (data) => {
    const temp_arr = data.filter((value, index, self) => {
      return value !== "" && self.indexOf(value) === index;
    });
    return [...temp_arr];
  };

  const handleActiveButton = (ind) => {
    setActiveIndex(ind);
  };

  const handleReportDownload = async () => {
    setIsDownloading(true);
    try {
      const count = 100;
      let events;
      let data = [];
      let activeStatus = patientTab === "all_patient" ? "" : patientTab;

      const effectiveIsFiltered = isNewUIPlace ? newUIIsFiltered : isFiltered;
      const effectiveSelectedOptions = isNewUIPlace
        ? newUISelectedOptions
        : selectedOptions;
      const effectiveFromValue = isNewUIPlace ? newUIFromValue : fromValue;
      const effectiveToValue = isNewUIPlace ? newUIToValue : toValue;

      let start_time = isNaN(effectiveFromValue) ? "" : effectiveFromValue;
      let end_time = isNaN(effectiveToValue) ? "" : effectiveToValue;

      if (effectiveIsFiltered) {
        // Since we're applying filters, we reset the startIndex to 0
        events = `events=${effectiveSelectedOptions.timeline}&cervix_dilatations=${
          effectiveSelectedOptions.cervix_dilatation
        }&mother_statuses=${effectiveSelectedOptions.mother_status}&genders=${
          effectiveSelectedOptions.child_gender
        }&weights=${effectiveSelectedOptions.baby_birth_weight}&child_statuses=${
          effectiveSelectedOptions.child_status
        }&delivery_types=${effectiveSelectedOptions.delivery_type}&keyar_data=${
          effectiveSelectedOptions.keyar_data
        }&from_time=${isNaN(start_time) ? "" : start_time}&to_time=${
          isNaN(end_time) ? "" : end_time
        }&`;
      }

      if (
        totalPatient &&
        totalPatient !== undefined &&
        totalPatient !== 0 &&
        totalPatient !== ""
      ) {
        for (
          let startIndexInProcess = 0;
          startIndexInProcess < totalPatient;
          startIndexInProcess += count
        ) {
          await axios
            .get(
              `${
                urls. DEV_URL
              }v1/nurse/patients/?place_ids=${placeID}&current_status=${activeStatus}&exclude=keyar_dataset_params&start=${startIndexInProcess}&count=${count}&${
                isFiltered ? events : "&"
              }`,
              {
                headers: {
                  "Request-ID": "allow|me",
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${cookie}`,
                },
              }
            )
            .then((res) => {
              if (res.data) {
                const json_data = isJson(res.data);
                const patient_data = json_data.response.patients;
                data = data.concat(patient_data);
              }
            })
            .catch((err) => {
              console.log("Get Patient API failed", err);
              setLoading(false);
            });
        }

        await downloadReport(fieldMap, data);
      }
    } catch (err) {
      console.log("Report download failed", err);
    } finally {
      setIsDownloading(false);
    }
  };

  // This function will now be called when the "Apply & Search" button is clicked
  const handleApplyFilters = () => {
    setIsExpanded(false);
    setPatients([]); // Clear existing patients
    setTotalPatient(0);
    setIsFiltered(true); // This will trigger the effect to fetch reports with filters
    setStartIndex(0);
    setFetchTrigger((t) => !t); // Toggle the state to force useEffect to run
  };

  const fetchReports = useCallback(
    async (placeID) => {
      let count = 20;
      let activeStatus = patientTab === "all_patient" ? "" : patientTab;
      let events = "";

      // If starting from index 0, clear existing patients to prevent duplicates
      if (startIndex === 0) {
        setPatients([]);
      }

      const effectiveIsFiltered = isNewUIPlace ? newUIIsFiltered : isFiltered;
      const effectiveSelectedOptions = isNewUIPlace
        ? newUISelectedOptions
        : selectedOptions;
      const effectiveFromValue = isNewUIPlace ? newUIFromValue : fromValue;
      const effectiveToValue = isNewUIPlace ? newUIToValue : toValue;

      if (effectiveIsFiltered) {
        // Since we're applying filters, we reset the startIndex to 0
        events = `events=${effectiveSelectedOptions.timeline}&cervix_dilatations=${
          effectiveSelectedOptions.cervix_dilatation
        }&mother_statuses=${effectiveSelectedOptions.mother_status}&genders=${
          effectiveSelectedOptions.child_gender
        }&weights=${effectiveSelectedOptions.baby_birth_weight}&child_statuses=${
          effectiveSelectedOptions.child_status
        }&delivery_types=${effectiveSelectedOptions.delivery_type}&keyar_data=${
          effectiveSelectedOptions.keyar_data
        }&from_time=${isNaN(effectiveFromValue) ? "" : effectiveFromValue}&to_time=${
          isNaN(effectiveToValue) ? `${""}` : effectiveToValue
        }&`;
      }

      const url = `${
        urls. DEV_URL
      }v1/nurse/patients/?place_ids=${placeID}&current_status=${activeStatus}&forms=basic_detail,events,place_details,user_details,delivery_detail,labor_data,pa_pv_examination,obstetric_histories,alerts,complications&start=${startIndex}&count=${count}&${
        effectiveIsFiltered ? events : "&"
      }`;
      const headers = {
        "Request-ID": "allow|me",
        "Content-Type": "application/json",
        Authorization: `Bearer ${cookie}`,
      };

      setLoading(true);
      try {
        const res = await axios.get(url, { headers });
        const json_data = isJson(res.data);
        const data = json_data.response;
        // console.log(data)

        // if (data?.patients?.length > 0) {
        //   console.log("📦 FULL PATIENT OBJECTS FROM BACKEND:");
        //   data.patients.forEach((patient, index) => {
        //     console.log(`🧾 Patient ${index + 1}:`, patient);
        //   });
        // }
        setTotalPatient(data.total);

        if (data.total > 0) {
          // Prevent duplicate patients by checking if they already exist
          setPatients((prevPatients) => {
            const existingIds = new Set(prevPatients.map(p => p.basic_detail.id));
            const newPatients = data.patients.filter(p => !existingIds.has(p.basic_detail.id));
            return [...prevPatients, ...newPatients];
          });
          setStartIndex(startIndex + count);

          if (startIndex + count >= data.total) {
            setHasMore(false);
          }
        } else {
          setHasMore(false);
        }
      } catch (err) {
        console.error("Error in Fetching Data", err);
        setError(true);
        setTotalPatient(0);
        setPatients([]);
      } finally {
        setLoading(false);
      }
    },
    [
      fromValue,
      selectedOptions,
      toValue,
      isFiltered,
      startIndex,
      patientTab,
      isNewUIPlace,
      newUIIsFiltered,
      newUISelectedOptions,
      newUIFromValue,
      newUIToValue,
    ],
  );

  // Separate fetch used only by auto-refresh: replaces the visible page of
  // patients instead of appending, and never touches pagination's startIndex.
  const fetchReportsForAutoRefresh = useCallback(
    async (placeID, tempStartIndex) => {
      let count = 20;
      let activeStatus = patientTab === "all_patient" ? "" : patientTab;
      let events = "";

      const effectiveIsFiltered = isNewUIPlace ? newUIIsFiltered : isFiltered;
      const effectiveSelectedOptions = isNewUIPlace
        ? newUISelectedOptions
        : selectedOptions;
      const effectiveFromValue = isNewUIPlace ? newUIFromValue : fromValue;
      const effectiveToValue = isNewUIPlace ? newUIToValue : toValue;

      if (effectiveIsFiltered) {
        events = `events=${effectiveSelectedOptions.timeline}&cervix_dilatations=${
          effectiveSelectedOptions.cervix_dilatation
        }&mother_statuses=${effectiveSelectedOptions.mother_status}&genders=${
          effectiveSelectedOptions.child_gender
        }&weights=${effectiveSelectedOptions.baby_birth_weight}&child_statuses=${
          effectiveSelectedOptions.child_status
        }&delivery_types=${effectiveSelectedOptions.delivery_type}&keyar_data=${
          effectiveSelectedOptions.keyar_data
        }&from_time=${isNaN(effectiveFromValue) ? "" : effectiveFromValue}&to_time=${
          isNaN(effectiveToValue) ? `${""}` : effectiveToValue
        }&`;
      }

      const url = `${
        urls. DEV_URL
      }v1/nurse/patients/?place_ids=${placeID}&current_status=${activeStatus}&forms=basic_detail,events,place_details,user_details,delivery_detail,labor_data,pa_pv_examination,obstetric_histories,alerts,complications&start=${tempStartIndex}&count=${count}&${
        effectiveIsFiltered ? events : "&"
      }`;
      const headers = {
        "Request-ID": "allow|me",
        "Content-Type": "application/json",
        Authorization: `Bearer ${cookie}`,
      };

      try {
        const res = await axios.get(url, { headers });
        const json_data = isJson(res.data);
        const data = json_data.response;

        setTotalPatient(data.total);

        if (data.total > 0) {
          setPatients(data.patients);
          setStartIndex(count);
          setHasMore(count < data.total);
        } else {
          setHasMore(false);
          setPatients([]);
        }
      } catch (err) {
        console.error("Error in Auto-refresh", err);
        // Don't set error state for auto-refresh failures — a transient
        // background-refresh error shouldn't block the page the user is on.
      }
    },
    [
      fromValue,
      selectedOptions,
      toValue,
      isFiltered,
      patientTab,
      cookie,
      isNewUIPlace,
      newUIIsFiltered,
      newUISelectedOptions,
      newUIFromValue,
      newUIToValue,
    ],
  );

  const fetchPlaceIDs = useCallback(async () => {
    if (loading) return;
    setLoading(true);
    await axios
      .get(`${urls. DEV_URL}v1/website/places/`, {
        headers: {
          "Request-ID": "allow|me",
          "Content-Type": "application/json",
          Authorization: `Bearer ${cookie}`,
        },
      })
      .then((res) => {
        if (res.data) {
          const json_data = isJson(res.data);
          setPlaces(json_data.response);
          const associate_place = json_data.response;
          setPlaceDetails(associate_place);
          let place_ids;
          const allPlaceIds = associate_place.map((obj) => obj.id).toString();
          if (isNewUIPlace) {
            // New UI: place ids are resolved entirely inside
            // NewPatientReportToolbar (Zone/District/Facility hierarchy from
            // facility-overview v2) and handed to us via onApply.
            place_ids = newUIPlaceIds || allPlaceIds;
          } else if (isFiltered) {
            // Process response to fetch reports based on new places

            const filteredData = associate_place.filter((place) => {
              return (
                (filters.State === "All" || filters.State === place.state) &&
                (filters.District === "All" ||
                  filters.District === place.district) &&
                (filters.Facility === "All" || filters.Facility === place.name)
              );
            });
            place_ids = filteredData.map((obj) => obj.id).toString();
          } else {
            place_ids = allPlaceIds;
          }
          setPlaceID(place_ids);
          fetchReports(place_ids);
          fetchAnalyticsData(place_ids);
          setLoading(false);
        }
      })
      .catch((err) => {
        setPlaceID("");
        setError(true);
        setLoading(false);
      });
  }, [
    filters,
    isFiltered,
    fetchReports,
    cookie,
    loading,
    isNewUIPlace,
    newUIPlaceIds,
  ]);

  useEffect(() => {
    fetchPlaceIDs();
  }, [fetchTrigger, patientTab]);

  const search = async (searchString) => {
    // If search is empty, reset to default view
    if (!searchString || searchString.trim() === '') {
      setIsSearch(false);
      setSearchPatients([]);
      setSearchError(false);
      setPatients([]);
      setStartIndex(0);
      setHasMore(true);
      setTotalPatient(0);
      setFetchTrigger((t) => !t); // This will trigger fetchPlaceIDs
      return;
    }

    setLoading(true);
    setIsExpanded(false);

    if (searchString.length > 0 || searchID.length > 0) {
      setIsSearch(true);
    }

    await axios
      .get(
        `${urls. DEV_URL}v1/nurse/patients/?place_ids=${placeID}&search=${searchString}&forms=basic_detail,events,place_details,user_details,delivery_detail,labor_data,pa_pv_examination,alerts&`,
        {
          headers: {
            "Request-ID": "allow|me",
            "Content-Type": "application/json",
            Authorization: `Bearer ${cookie}`,
          },
        }
      )
      .then((res) => {
        const json_data = isJson(res.data);
        setSearchPatients(json_data.response);
        setSearchError(false);
        setPatients([]);
        setTotalPatient(0);
        setHasMore(false);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error in Fetching Patient Data", err);
        setSearchPatients([]);
        setIsSearch(false);
        setSearchError(true);
        setLoading(false);
      });
  };

   useEffect(() => {
  const trimmedSearch = searchID.trim();

  const timer = setTimeout(() => {
    // reset to default list when input becomes empty
    if (trimmedSearch === "") {
      search("");
      return;
    }

    // avoid API hit for single character
    if (trimmedSearch.length >= 2) {
      search(trimmedSearch);
    }
  }, 500);

  return () => clearTimeout(timer);
}, [searchID]);


  const formatString = (inputString) => {
    const words = inputString.split("_");
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1)
    );
    const resultString = capitalizedWords.join(" ");
    return resultString;
  };

  const openViewFile = (patientId, patientName, lastUpdateTime, mrn) => {
    const data = {
      patient_name: patientName,
      patient_id: patientId,
      last_update_time: lastUpdateTime,
      mrn: mrn,
    };
    navigate(`/dashboard/patient/${patientId}`, { state: data });
  };

  const openViewPartograph = (patient_id) => {
    setPatientID(patient_id);
    setOpenPartograph(true);
    navigate(`/dashboard/partograph/${patient_id}`);
  };

  const handleNumericValue = (e) => {
    // Allow the default behavior for pasting
    if (e.ctrlKey || e.metaKey) {
      return;
    }

    // Prevent any non-numeric key presses
    if (
      !/^\d+$/.test(e.key) &&
      ![
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Home",
        "End",
      ].includes(e.key)
    ) {
      e.preventDefault();
    }
  };

  const handleNumericPaste = (e) => {
    e.preventDefault();

    const pastedText = e.clipboardData.getData("text");
    const numericText = pastedText.replace(/\D/g, ""); // keep digits only

    if (numericText.length > 0) {
      document.execCommand("insertText", false, numericText);
    }
  };

  const formatLabel = (label) => {
    return label
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const getDisplayName = (category, value) => {
    const formattedCategory = formatLabel(category);
    const categoryData = medicalData[category];
    const categoryKey = Object.keys(categoryData).find(
      (key) => categoryData[key] === value
    );
    const formattedValue = formatLabel(categoryKey || value);
    return `${formattedCategory}: ${formattedValue}`;
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      search(searchID);
    }
  };

  // useEffect(() => {
  //   fetchAnalyticsData(placeID);
  // },[placeID])

  const fetchAnalyticsData = useCallback(
    async (placeIDs) => {
      setLoading(true);

      // Get active status based on patient tab filter
      let activeStatus = patientTab === "all_patient" ? "" : patientTab;

      const effectiveIsFiltered = isNewUIPlace ? newUIIsFiltered : isFiltered;
      const effectiveFromValue = isNewUIPlace ? newUIFromValue : fromValue;
      const effectiveToValue = isNewUIPlace ? newUIToValue : toValue;

      let events = "";

      if (effectiveIsFiltered) {
        events = `from_time=${isNaN(effectiveFromValue) ? "" : effectiveFromValue}&to_time=${
          isNaN(effectiveToValue) ? `${""}` : effectiveToValue
        }&`;
      }

      await axios
        .get(
          `${urls.DEV_URL}api/v3/dashboard-data/?place_ids=${placeIDs}&current_status=${activeStatus}&${
            effectiveIsFiltered ? events : "&"
          }`,
          {
            headers: {
              "Request-ID": "allow|me",
              "Content-Type": "application/json",
              Authorization: `Bearer ${cookie}`,
            },
          }
        )
        .then((res) => {
          if (res.data) {
            const json_data = isJson(res.data);
            //console.log(json_data)
            setAnalyticData(json_data);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log("Analytics failed, ignoring");
          setLoading(false);
        });
    },
    [
      fromValue,
      toValue,
      isFiltered,
      value1,
      value2,
      patientTab,
      isNewUIPlace,
      newUIIsFiltered,
      newUIFromValue,
      newUIToValue,
    ],
  );

  const fetchOverviewAnalytics = async () => {
    const headers = {
      "Request-ID": "allow|me",
      "Content-Type": "application/json",
      Authorization: `Bearer ${cookie}`,
    };
    const params = new URLSearchParams();
    if (placeID) {
      params.append("place_ids", placeID);
    }
    const overviewFrom = isNewUIPlace
      ? newUIFromValue && dayjs.unix(newUIFromValue)
      : value1;
    const overviewTo = isNewUIPlace
      ? newUIToValue && dayjs.unix(newUIToValue)
      : value2;
    if (overviewFrom && overviewTo) {
      params.append("from_time", overviewFrom.format("YYYY-MM-DD"));
      params.append("to_time", overviewTo.add(1, "day").format("YYYY-MM-DD"));
    }
    const queryString = params.toString();
    try {
      const facilityRes = await axios.get(
        `${urls.DEV_URL}api/analytics/facility-overview/?${queryString}`,
        { headers },
      );
      return {
        facilityOverview: facilityRes.data,
      };
    } catch (err) {
      console.log("Overview analytics fetch failed", err);
      return { facilityOverview: {} };
    }
  };

  // Refreshes patient + analytics data every 5 minutes. Places/facilities are
  // static and are intentionally never re-fetched here.
  const performAutoRefresh = useCallback(async () => {
    if (
      isSearchRef.current ||
      errorRef.current ||
      loadingRef.current ||
      isDownloadingRef.current ||
      startIndexRef.current > 20
    ) {
      // Skip this cycle while the user is searching, an error is showing, a
      // fetch is already in flight, a download is in progress, or the user
      // has scrolled past the first page (replacing their loaded list here
      // would silently discard scroll progress).
      return;
    }

    if (!placeID) return;

    setIsAutoRefreshing(true);
    const refreshTime = new Date();

    try {
      await fetchReportsForAutoRefresh(placeID, 0);
      await fetchAnalyticsData(placeID);

      if (onDataRefresh) {
        onDataRefresh(refreshTime);
      }
      if (syncRefreshTimeRef.current) {
        syncRefreshTimeRef.current(refreshTime);
      }
    } catch (err) {
      console.error("Auto-refresh failed", err);
    } finally {
      setIsAutoRefreshing(false);
    }
  }, [placeID, fetchReportsForAutoRefresh, fetchAnalyticsData, onDataRefresh]);

  const { syncLastRefreshTime } = useAutoRefresh(performAutoRefresh, 5, true, [
    placeID,
  ]);

  useEffect(() => {
    if (syncLastRefreshTime) {
      syncRefreshTimeRef.current = syncLastRefreshTime;
    }
  }, [syncLastRefreshTime]);

  const getAgeFromDOB = (dob) => {
    const dobDate = new Date(dob);
    const currentDate = new Date();

    let years = currentDate.getFullYear() - dobDate.getFullYear();
    let months = currentDate.getMonth() - dobDate.getMonth();
    let days = currentDate.getDate() - dobDate.getDate();

    if (days < 0) {
      months -= 1;
      days += new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      ).getDate();
    }
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    return years > 1
      ? `${years} years`
      : years === 1
      ? months > 0
        ? `1 year ${months} months`
        : `1 year`
      : months > 1
      ? `${months} months`
      : months === 1
      ? `${months} month`
      : `${days} days`;
  };

  //  console.log(toValue, fromValue)

  const searchBarNode = (
    <div
      className={
        isNewUIPlace ? "search-input-div graph-search-input-div" : "search-input-div"
      }
      onKeyDown={handleKeyPress}
    >
      <img src="/search.svg" alt="Search Icon" className="search-icon" />
      <input
        type="text"
        placeholder={
          isNewUIPlace
            ? "Search by patient Name, Id, MRN no."
            : "Search by patient Name, Id, MRN no."
        }
        value={searchID}
        onChange={(e) => setSearchID(e.target.value)}
        className="search-input"
      />
      {!isNewUIPlace && (
        <button className="search-button" onClick={() => search(searchID)}>
          Search
        </button>
      )}
    </div>
  );

  return (
    <div className="report-section">
      {error ? (
        <div className="error-div">
          <Reload />
        </div>
      ) : isDownloading ? (
        <div
          className="loading-div"
          style={{ marginTop: `30%`, marginRight: `10%` }}
        >
          <Loading text={"Downloading Please Wait...."} />
        </div>
      ) : (
        <>
          {isNewUIPlace &&
            searchPortalTarget &&
            createPortal(searchBarNode, searchPortalTarget)}
          <div className="reports">
            {isNewUIPlace && (
              <NewPatientReportToolbar
                patientTab={patientTab}
                accountType={accountType}
                cookie={cookie}
                onApply={handleNewUIApply}
              />
            )}

            {!isNewUIPlace && (
            <div className="search-filter-div">
              <div className="search-filter">
                {searchBarNode}

                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  sx={{
                    width: "24%",
                    borderRadius: "100px",
                    border: "0.5px solid #A163F1",
                    height: "3.5rem",
                    background: "#F8F5FF",
                    fontFamily: "Poppins",
                    "&:hover": { border: "transparent" },
                    "& .MuiSelect-select": {
                      color: "#A163F1",
                      fontSize: "1.1rem",
                      fontWeight: "400",
                      mt: "5px",
                      ml: "10px",
                    },
                  }}
                  value={patientTab}
                  onChange={handleTabChange}
                >
                  {Object.entries(
                    accountType && ["Basic", "Navam"].includes(accountType)
                      ? basicTabOptions
                      : premuimTabOptions
                  ).map(([key, value]) => (
                    <StyledMenuItem key={value} value={value}>
                      {" "}
                      {key}{" "}
                    </StyledMenuItem>
                  ))}
                </Select>

                {isExpanded ? (
                  <div
                    className="close-button"
                    onClick={() => handleExpandClick()}
                  >
                    <img src={"/close-icon.svg"} alt="Close Icon" />
                    <p className="close-text">Close</p>
                  </div>
                ) : (
                  <div
                    className="filter-button"
                    onClick={() => handleExpandClick()}
                  >
                    <img
                      src={"/filter_icon.svg"}
                      alt="Select Filter"
                      className="filter-icon"
                    />
                    <p className="filter-text">Select Filters</p>
                  </div>
                )}
              </div>

              {isFiltered ? (
                <div className="selected-filters">
                  <StyledChip label="Clear All" onDelete={clearAllFilters} />
                  {value1 &&
                  value2 &&
                  fromValue &&
                  toValue &&
                  !isNaN(fromValue) &&
                  !isNaN(toValue) ? (
                    <StyleChip
                      label={`${getReadableDateOnly(
                        fromValue
                      )} - ${getReadableDateOnly(toValue)}`}
                      onDelete={() => clearSelectedFilters("dateFilters", null)}
                    />
                  ) : null}
                  {filters &&
                    Object.entries(filters).map(([key, value]) => {
                      return value !== "All" && value !== "" ? (
                        <StyleChip
                          label={`${key}: ${value}`}
                          onDelete={() => clearSelectedFilters(key, value)}
                        />
                      ) : null;
                    })}
                  {selectedOptions &&
                    Object.entries(selectedOptions).map(([category, value]) =>
                      value !== "All" && value !== "" ? (
                        <StyleChip
                          label={getDisplayName(category, value)}
                          onDelete={() => clearSelectedFilters(category, value)}
                        />
                      ) : null
                    )}
                </div>
              ) : (
                <div />
              )}

              {isAutoRefreshing && (
                <div className="auto-refresh-status">
                  <div className="auto-refresh-indicator">
                    <div className="refresh-spinner"></div>
                    <span className="refresh-text">Auto-refreshing...</span>
                  </div>
                </div>
              )}

              <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                <img
                  src="/hr-long.svg"
                  alt="hr"
                  style={{ width: "98%", margin: `10px` }}
                />

                <div className="filter-button-div">
                  <button
                    className={
                      activeIndex === 0
                        ? "active-filter-button"
                        : "inactive-filter-button"
                    }
                    onClick={() => handleActiveButton(0)}
                  >
                    Filter by Date
                  </button>

                  <button
                    className={
                      activeIndex === 1
                        ? "active-filter-button"
                        : "inactive-filter-button"
                    }
                    onClick={() => handleActiveButton(1)}
                    disabled={value1 && !value2}
                  >
                    Filter by Place
                  </button>
                  {accountType &&
                  !["Basic", "Navam", "Daksh SI"].includes(accountType) ? (
                    <button
                      className={
                        activeIndex === 2
                          ? "active-filter-button"
                          : "inactive-filter-button"
                      }
                      onClick={() => handleActiveButton(2)}
                      disabled={value1 && !value2}
                    >
                      Filter by Data
                    </button>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="filter-container">
                  {activeIndex === 0 ? (
                    <div className="container">
                      {showHelper && (
                        <p className="helper-text">
                          Please select the End Date
                        </p>
                      )}
                      <div
                        className="date-filter-container"
                        style={{ marginTop: `1.25rem` }}
                      >
                        <div className="date-picker">
                          <p className="text1"> Start Date </p>
                          <LocalDatePicker
                            value={value1}
                            setValue={handleStartDateChange}
                          />
                        </div>

                        <div className="date-picker">
                          <p className="text1">End Date</p>
                          <LocalDatePicker
                            value={value2}
                            setValue={handleEndDateChange}
                            open={openEndDateCalender}
                            onOpen={() => setOpenEndDateCalender(true)}
                            onClose={() => setOpenEndDateCalender(false)}
                            minDate={value1}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}

                  {activeIndex === 1
                    ? Object.keys(availableFilters).map((filterType, key) => (
                        <Filter
                          key={key}
                          heading={filterType}
                          options={availableFilters[filterType]}
                          onFilterChange={handleFilterChange}
                          selectedValue={filters[filterType]}
                        />
                      ))
                    : null}

                  {activeIndex === 2
                    ? Object.keys(medicalData).map((obj, index) => (
                        <div key={index}>
                          <StyledInputLabel
                            variant="standard"
                            className="input-label"
                          >
                            {" "}
                            {formatString(obj)}{" "}
                          </StyledInputLabel>
                          <StyledSelect
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            MenuProps={{
                              anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left",
                              },
                              transformOrigin: {
                                vertical: "top",
                                horizontal: "left",
                              },
                              getContentAnchorEl: null, // This is important to prevent the Menu from using the Select input as the anchor
                            }}
                            value={selectedOptions[obj] || "All"}
                            onChange={(event) => handleSelectChange(event, obj)}
                          >
                            {Object.entries(medicalData[obj]).map(
                              ([label, value], index) => {
                                return (
                                  <StyledMenuItem key={index} value={value}>
                                    {label}
                                  </StyledMenuItem>
                                );
                              }
                            )}
                          </StyledSelect>
                        </div>
                      ))
                    : null}
                </div>

                <div className="apply-filter-container">
                  <button
                    disabled={!isFiltered || openEndDateCalender}
                    className={
                      isFiltered && !openEndDateCalender
                        ? "apply-button"
                        : "inactive-apply-button"
                    }
                    onClick={() => handleApplyFilters()}
                  >
                    Apply & Search
                  </button>
                </div>
              </Collapse>
            </div>
            )}
          </div>

          <div className="reports">
            {searchError ? (
              <div className="search-error-div">No Patients Found</div>
            ) : loading && isSearch ? (
              <Loading />
            ) : (
              <>
                <div className="result-container">
                  <p>
                    {" "}
                    Results found -{" "}
                    {totalPatient
                      ? totalPatient
                      : searchPatients && searchPatients.length > 0
                      ? searchPatients.length
                      : "No patient found"}
                  </p>
                  {accountType && ["Premium"].includes(accountType) ? (
                    <p
                      className="download-link"
                      onClick={() => handleReportDownload()}
                    >
                      {" "}
                      Download All Reports{" "}
                    </p>
                  ) : accountType && ["Basic"].includes(accountType) ? (
                    <div className="reports-alert-div">
                      <img
                        src="/alert_count.png"
                        Alt="Alert Image"
                        width={30}
                        height={30}
                      />
                      <p className="reports-alert-text">
                        Active Alerts Count:{" "}
                        {analyticData.total_alert_count || "--"}
                      </p>
                    </div>
                  ) : null}
                </div>

                <div className="patient-data-section">
                  <InfiniteScroll
                    dataLength={
                      isSearch ? searchPatients.length : patients.length
                    }
                    next={
                      searchPatients && searchPatients.length > 0
                        ? null
                        : fetchPlaceIDs
                    }
                    hasMore={hasMore}
                    loader={<Loading />}
                  >
                    <div className="patient-list">
                      {(patients.length > 0 && patients) ||
                      (searchPatients && searchPatients.length > 0)
                        ? (patients.length > 0 ? patients : searchPatients).map(
                            (obj, index) => {
                              let patientId = obj.basic_detail.id;
                              let lastUpdateTime =
                                obj.basic_detail.last_update_time;
                              let patientName = obj.basic_detail.name;
                              let mrn = obj.basic_detail.mrn;
                              let displayPatientIdentifier = mrn && mrn !="NA" ? mrn : patientId

                              // if cervix_diameter is less than 5 than view partograph button will be disable else it will be able
                              const new_data =
                                obj.labor_data &&
                                obj.labor_data.map((obj) => ({
                                  ...obj,
                                  data_time: (obj.data_time *= 1000),
                                }));
                              const sorted_data =
                                new_data &&
                                new_data.sort((a, b) =>
                                  a.data_time > b.data_time ? 1 : -1
                                );
                              let disablePartograph =
                                sorted_data &&
                                sorted_data.filter(
                                  (obj) =>
                                    obj.data_type === "cervix_diameter" &&
                                    parseInt(obj.param_1) >= 5
                                ).length > 0
                                  ? true
                                  : false;

                              const refer_details = getReferralDetails(
                                obj.events,
                                obj.place_details
                              );

                              let referralArray = [];

                              if (refer_details.length > 0) {
                                let placeIdExists = places.find(
                                  (place) =>
                                    place.id ===
                                    refer_details[refer_details.length - 1]
                                      .referred_place_id
                                );

                                if (placeIdExists) {
                                  if (
                                    refer_details[refer_details.length - 1]
                                      .refer_message_mother.length > 0
                                  ) {
                                    let refer_mother_from = {
                                      refer_place:
                                        refer_details[refer_details.length - 1]
                                          .place_name,
                                      refer_type: "from",
                                      refer_person: "Mother",
                                      refer_mother_msg: Array.isArray(
                                        refer_details[refer_details.length - 1]
                                          .refer_message_mother
                                      )
                                        ? refer_details[
                                            refer_details.length - 1
                                          ].refer_message_mother.join(" , ")
                                        : " ",
                                    };

                                    referralArray.push(refer_mother_from);
                                  }

                                  if (
                                    refer_details[refer_details.length - 1]
                                      .refer_message_child.length > 0
                                  ) {
                                    let refer_child_from = {
                                      refer_place:
                                        refer_details[refer_details.length - 1]
                                          .place_name,
                                      refer_type: "from",
                                      refer_person: "Child",
                                      refer_child_msg: Array.isArray(
                                        refer_details[refer_details.length - 1]
                                          .refer_message_child
                                      )
                                        ? refer_details[
                                            refer_details.length - 1
                                          ].refer_message_child.join(" , ")
                                        : " ",
                                    };
                                    referralArray.push(refer_child_from);
                                  }
                                } else {
                                  if (
                                    refer_details[refer_details.length - 1]
                                      .refer_message_mother.length > 0
                                  ) {
                                    let refer_mother_to = {
                                      refer_place:
                                        refer_details[refer_details.length - 1]
                                          .referred_place_name,
                                      refer_type: "to",
                                      refer_person: "Mother",
                                      refer_mother_msg: Array.isArray(
                                        refer_details[refer_details.length - 1]
                                          .refer_message_mother
                                      )
                                        ? refer_details[
                                            refer_details.length - 1
                                          ].refer_message_mother.join(" , ")
                                        : "",
                                    };
                                    referralArray.push(refer_mother_to);
                                  }

                                  if (
                                    refer_details[refer_details.length - 1]
                                      .refer_message_child.length > 0
                                  ) {
                                    let refer_child_to = {
                                      refer_place:
                                        refer_details[refer_details.length - 1]
                                          .referred_place_name,
                                      refer_type: "to",
                                      refer_person: "Child",
                                      refer_child_msg: Array.isArray(
                                        refer_details[refer_details.length - 1]
                                          .refer_message_child
                                      )
                                        ? refer_details[
                                            refer_details.length - 1
                                          ].refer_message_child.join(" , ")
                                        : "",
                                    };
                                    referralArray.push(refer_child_to);
                                  }
                                }
                              }

                              return (
                                <>
                                  {
                                    <div
                                      key={`patient-${obj.basic_detail.id}-${index}`}
                                      className={`patient-obj ${
                                        patientTab === "all_patient" &&
                                        obj.basic_detail.current_status ===
                                          "post_partum_process"
                                          ? "postpartum-border"
                                          : patientTab === "all_patient" &&
                                            obj.basic_detail.current_status ===
                                              "intra_partum_process"
                                          ? "intrapartum-border"
                                          : patientTab === "all_patient" &&
                                            obj.basic_detail.current_status ===
                                              "completed"
                                          ? "completed-border"
                                          : null
                                      }`}
                                    >
                                      <div className="patient-details">
                                        {obj.basic_detail?.name.length > 30 ? (
                                          <span
                                            style={{ display: "inline-flex" }}
                                          >
                                            <TooltipComponent
                                              title={`${obj.basic_detail.name}`}
                                              content={limitStr(
                                                obj.basic_detail.name,
                                                30,
                                                "patient-data"
                                              )}
                                            />
                                            <span
                                              style={{
                                                display: "inline-block",
                                              }}
                                            >
                                              <p className="patient-data">
                                                {"  "} ({displayPatientIdentifier}) -
                                                {accountType &&
                                                ["Navam"].includes(accountType)
                                                  ? getAgeFromDOB(
                                                      obj.basic_detail.dob
                                                    )
                                                  : obj.basic_detail.age &&
                                                    obj.basic_detail.age !==
                                                      "NA"
                                                  ? `${obj.basic_detail.age} years`
                                                  : "NA"}
                                              </p>
                                              {accountType &&
                                                ["Navam"].includes(
                                                  accountType
                                                ) && (
                                                  <img
                                                    src="/navam-child.svg"
                                                    alt="Child Image"
                                                  />
                                                )}
                                            </span>
                                          </span>
                                        ) : (
                                          <div className="patient-data">
                                            <p className="patient-data-text">
                                              {obj.basic_detail.name} ({displayPatientIdentifier}) -
                                              {accountType &&
                                              ["Navam"].includes(accountType)
                                                ? getAgeFromDOB(
                                                    obj.basic_detail.dob
                                                  )
                                                : obj.basic_detail.age &&
                                                  obj.basic_detail.age !== "NA"
                                                ? `${obj.basic_detail.age} years`
                                                : "NA"}
                                            </p>
                                            {accountType &&
                                              ["Navam"].includes(
                                                accountType
                                              ) && (
                                                <img
                                                  src="/navam-child.svg"
                                                  alt="Child Image"
                                                />
                                              )}
                                          </div>
                                        )}

                                        <div className="patient-update">
                                          {patientTab === "all_patient" &&
                                          obj.basic_detail.current_status ===
                                            "post_partum_process" &&
                                          accountType &&
                                          accountType.length > 0 &&
                                          accountType !== "Basic" ? (
                                            <div className="postpartum-box">
                                              {" "}
                                              Postpartum{" "}
                                            </div>
                                          ) : patientTab === "all_patient" &&
                                            obj.basic_detail.current_status ===
                                              "intra_partum_process" ? (
                                            <div className="intrapartum-box">
                                              {accountType &&
                                              ["Basic", "Navam"].includes(
                                                accountType
                                              )
                                                ? "Live Patients"
                                                : "Intrapartum"}
                                            </div>
                                          ) : patientTab === "all_patient" &&
                                            obj.basic_detail.current_status ===
                                              "completed" ? (
                                            <div className="completed-box">
                                              {" "}
                                              Completed
                                            </div>
                                          ) : null}

                                          <div className="update">
                                            <img
                                              src="/patient_Updation.svg"
                                              alt="Update Icon"
                                            ></img>
                                            <p className="last-sync-text">
                                              {" "}
                                              Last Sync :{" "}
                                              {obj.basic_detail
                                                ?.last_update_time
                                                ? getReadableTime(
                                                    obj.basic_detail
                                                      .last_update_time
                                                  )
                                                : ""}
                                            </p>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="information">
                                        <div className="patient-info">
                                          <div>
                                            <p className="text-1">
                                              Admitted Facility
                                            </p>
                                            {obj?.place_details[
                                              obj?.basic_detail
                                                ?.registration_place_id
                                            ]?.name &&
                                            obj?.place_details[
                                              obj?.basic_detail
                                                ?.registration_place_id
                                            ]?.name.length > 18 ? (
                                              <TooltipComponent
                                                className="text-2"
                                                title={`${
                                                  obj?.place_details[
                                                    obj?.basic_detail
                                                      ?.registration_place_id
                                                  ]?.name
                                                }`}
                                                content={limitStr(
                                                  obj?.place_details[
                                                    obj?.basic_detail
                                                      ?.registration_place_id
                                                  ]?.name,
                                                  18,
                                                  "text-2"
                                                )}
                                              />
                                            ) : (
                                              <p className="text-2">
                                                {obj?.place_details[
                                                  obj?.basic_detail
                                                    ?.registration_place_id
                                                ]?.name
                                                  ? obj?.place_details[
                                                      obj?.basic_detail
                                                        ?.registration_place_id
                                                    ]?.name
                                                  : "--"}
                                              </p>
                                            )}
                                          </div>

                                          {accountType &&
                                          !["Daksh SI"].includes(
                                            accountType
                                          ) ? (
                                            <div>
                                              <p className="text-1">Doctor</p>
                                              {obj.user_details[
                                                obj.basic_detail
                                                  .registration_doctor_id
                                              ]?.first_name &&
                                              obj.user_details[
                                                obj.basic_detail
                                                  .registration_doctor_id
                                              ]?.first_name.length > 18 ? (
                                                <TooltipComponent
                                                  title={`${
                                                    obj.user_details[
                                                      obj.basic_detail
                                                        .registration_doctor_id
                                                    ]?.first_name
                                                  }`}
                                                  content={limitStr(
                                                    obj.user_details[
                                                      obj.basic_detail
                                                        .registration_doctor_id
                                                    ]?.first_name,
                                                    18,
                                                    "text-2"
                                                  )}
                                                />
                                              ) : (
                                                <p className="text-2">
                                                  {obj.user_details[
                                                    obj.basic_detail
                                                      .registration_doctor_id
                                                  ]?.first_name
                                                    ? obj.user_details[
                                                        obj.basic_detail
                                                          .registration_doctor_id
                                                      ]?.first_name
                                                    : "--"}
                                                </p>
                                              )}
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          <div>
                                            <p className="text-1">Nurse</p>
                                            {obj.user_details[
                                              obj.basic_detail
                                                .registration_worker_id
                                            ]?.first_name &&
                                            obj.user_details[
                                              obj.basic_detail
                                                .registration_worker_id
                                            ]?.first_name.length > 18 ? (
                                              <TooltipComponent
                                                title={`${
                                                  obj.user_details[
                                                    obj.basic_detail
                                                      .registration_worker_id
                                                  ]?.first_name
                                                }`}
                                                content={limitStr(
                                                  obj.user_details[
                                                    obj.basic_detail
                                                      .registration_worker_id
                                                  ]?.first_name,
                                                  18,
                                                  "text-2"
                                                )}
                                              />
                                            ) : (
                                              <p className="text-2">
                                                {obj.user_details[
                                                  obj.basic_detail
                                                    .registration_worker_id
                                                ]?.first_name
                                                  ? obj.user_details[
                                                      obj.basic_detail
                                                        .registration_worker_id
                                                    ]?.first_name
                                                  : "--"}
                                              </p>
                                            )}
                                          </div>

                                          <div>
                                            <p className="text-1">
                                              {" "}
                                              {accountType &&
                                              ["Navam"].includes(accountType)
                                                ? "Phone No"
                                                : "Patient Phone No"}
                                            </p>
                                            <p className="text-2">
                                              {" "}
                                              {obj?.basic_detail?.phone === "NA"
                                                ? "--"
                                                : obj.basic_detail.phone}{" "}
                                            </p>
                                          </div>

                                          {accountType &&
                                          ["Navam"].includes(accountType) ? (
                                            <div>
                                              <p className="text-1">Sex</p>

                                              <p className="text-2">
                                                {obj.basic_detail.gender
                                                  ? obj.basic_detail.gender ===
                                                    "FEMALE"
                                                    ? "Female"
                                                    : obj.basic_detail
                                                        .gender === "MALE"
                                                    ? "Male"
                                                    : obj.basic_detail.gender
                                                  : "--"}
                                              </p>
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          ["Navam"].includes(accountType) ? (
                                            <div>
                                              <p className="text-1">DOB</p>

                                              <p className="text-2">
                                                {obj.basic_detail.dob
                                                  ? obj.basic_detail.dob
                                                  : "--"}
                                              </p>
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          ["Basic"].includes(accountType) ? (
                                            <div>
                                              <p className="text-1">
                                                Number of Fetus
                                              </p>
                                              <p className="text-2">
                                                {obj?.obstetric_histories &&
                                                obj?.obstetric_histories
                                                  .length > 0
                                                  ? obj.obstetric_histories[0]
                                                      .no_of_children
                                                  : "--"}
                                              </p>
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          ["Basic"].includes(accountType) ? (
                                            <div>
                                              <p className="text-1">
                                                Presentation
                                              </p>
                                              <p className="text-2">
                                                {obj.pa_pv_examination
                                                  .presentation
                                                  ? obj.pa_pv_examination
                                                      .presentation
                                                  : "--"}
                                              </p>
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          ![
                                            "Basic",
                                            "Daksh SI",
                                            "Navam",
                                          ].includes(accountType) ? (
                                            <div>
                                              <p className="text-1">Guardian</p>
                                              {obj?.basic_detail
                                                ?.guardian_name &&
                                              obj?.basic_detail?.guardian_name
                                                .length > 18 ? (
                                                <TooltipComponent
                                                  title={`${obj.basic_detail.guardian_name}`}
                                                  content={limitStr(
                                                    obj.basic_detail
                                                      .guardian_name,
                                                    18,
                                                    "text-2"
                                                  )}
                                                />
                                              ) : (
                                                <p className="text-2">
                                                  {obj.basic_detail
                                                    .guardian_name
                                                    ? obj.basic_detail
                                                        .guardian_name
                                                    : "--"}
                                                </p>
                                              )}
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          !["Navam"].includes(
                                            accountType
                                          ) ? (
                                            <div>
                                              <p className="text-1">
                                                Admission Time
                                              </p>
                                              <p className="text-2">
                                                {obj.events.filter(
                                                  (obj) =>
                                                    obj.event === "registered"
                                                )[0] !== undefined
                                                  ? getReadableTime(
                                                      obj.events.filter(
                                                        (obj) =>
                                                          obj.event ===
                                                          "registered"
                                                      )[0].event_time
                                                    )
                                                  : "--"}
                                              </p>
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          !["Basic", "Navam"].includes(
                                            accountType
                                          ) ? (
                                            <div>
                                              <p className="text-1">
                                                Delivery Time
                                              </p>
                                              <p className="text-2">
                                                {obj.events.filter(
                                                  (obj) =>
                                                    obj.event === "delivered"
                                                )[0] !== undefined
                                                  ? getReadableTime(
                                                      obj.events.filter(
                                                        (obj) =>
                                                          obj.event ===
                                                          "delivered"
                                                      )[0].event_time
                                                    )
                                                  : "--"}
                                              </p>
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          ["Premium", "Daksh SI"].includes(
                                            accountType
                                          ) ? (
                                            <div>
                                              <p className="text-1">
                                                Discharge Time
                                              </p>
                                              {obj.basic_detail
                                                .current_status ===
                                                "completed" &&
                                              obj.events.length !==
                                                undefined ? (
                                                <p className="text-2">
                                                  {obj.events.filter(
                                                    (obj) =>
                                                      obj.event === "completed"
                                                  )[0] !== undefined
                                                    ? getReadableTime(
                                                        obj.events.filter(
                                                          (obj) =>
                                                            obj.event ===
                                                            "completed"
                                                        )[0].event_time
                                                      )
                                                    : "--"}{" "}
                                                </p>
                                              ) : (
                                                <p> -- </p>
                                              )}
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          ![
                                            "Basic",
                                            "Daksh SI",
                                            "Navam",
                                          ].includes(accountType) ? (
                                            <div>
                                              <p className="text-1">
                                                Mother Status
                                              </p>
                                              {Object.keys(obj.delivery_detail)
                                                .length !== undefined &&
                                              Object.keys(obj.delivery_detail)
                                                .length > 0 ? (
                                                <p className="text-2">
                                                  {" "}
                                                  {
                                                    obj.delivery_detail
                                                      .mother_status
                                                  }{" "}
                                                </p>
                                              ) : (
                                                <p> -- </p>
                                              )}
                                            </div>
                                          ) : (
                                            <></>
                                          )}

                                          {accountType &&
                                          ![
                                            "Basic",
                                            "Daksh SI",
                                            "Navam",
                                          ].includes(accountType) ? (
                                            <div>
                                              <p className="text-1">
                                                Child Status
                                              </p>
                                              {Object.keys(obj.delivery_detail)
                                                .length !== undefined &&
                                              Object.keys(obj.delivery_detail)
                                                .length > 0 ? (
                                                <p className="text-2">
                                                  {obj.delivery_detail
                                                    ?.child_details.length > 0
                                                    ? getChildStatusString(
                                                        obj.delivery_detail
                                                      )
                                                    : "--"}
                                                </p>
                                              ) : (
                                                <p>--</p>
                                              )}
                                            </div>
                                          ) : (
                                            <></>
                                          )}
                                        </div>

                                        <img
                                          src="/horizontal_Icon.svg"
                                          alt=""
                                        />

                                        {accountType &&
                                          ["Premium", "Basic"].includes(
                                            accountType
                                          ) && (
                                            <div className="Alerts">
                                              <CardAlerts
                                                patientID={obj.id}
                                                patientName={patientName}
                                                lastUpdateTime={lastUpdateTime}
                                                alerts={obj.alerts}
                                                complications={
                                                  obj.complications
                                                }
                                                statusTab={patientTab}
                                              />
                                            </div>
                                          )}

                                        <div
                                          className={
                                            accountType &&
                                            ["Basic", "Premium"].includes(
                                              accountType
                                            )
                                              ? "patient-card-bottom"
                                              : "osi-buttons"
                                          }
                                        >
                                          {accountType &&
                                            ["Basic", "Premium"].includes(
                                              accountType
                                            ) && (
                                              <p
                                                style={{
                                                  fontSize: `1.1rem`,
                                                  color: `rgba(187, 141, 245, 1)`,
                                                }}
                                              >
                                                {" "}
                                                Patient's Alert Count :{" "}
                                                {obj.alerts.length}
                                              </p>
                                            )}

                                          <div
                                            className={
                                              accountType &&
                                              accountType.length > 0 &&
                                              accountType !== "Daksh SI" &&
                                              accountType !== "Basic"
                                                ? "buttons"
                                                : "osi-buttons"
                                            }
                                          >
                                            {accountType &&
                                            ["Premium"].includes(
                                              accountType
                                            ) ? (
                                              <button
                                                disabled={!disablePartograph}
                                                className={
                                                  disablePartograph
                                                    ? "active-partograph-button"
                                                    : "inactive-partograph-button"
                                                }
                                                onClick={(e) =>
                                                  openViewPartograph(patientId)
                                                }
                                              >
                                                View Partograph
                                              </button>
                                            ) : (
                                              <></>
                                            )}

                                            <button
                                              className="active-button"
                                              onClick={() =>
                                                openViewFile(
                                                  patientId,
                                                  patientName,
                                                  lastUpdateTime,
                                                  mrn
                                                )
                                              }
                                            >
                                              {" "}
                                              View Files{" "}
                                            </button>
                                          </div>
                                        </div>

                                        {accountType &&
                                          ["Premium"].includes(accountType) && (
                                            <div className="referral-div">
                                              {referralArray &&
                                              referralArray.length > 0
                                                ? referralArray.map(
                                                    (value, index) => {
                                                      return (
                                                        <div
                                                          className={`referral-info ${
                                                            value.refer_person ===
                                                              "Mother" &&
                                                            value.refer_type ===
                                                              "to"
                                                              ? "yellow-background"
                                                              : value.refer_person ===
                                                                  "Mother" &&
                                                                value.refer_type ===
                                                                  "from"
                                                              ? "blue-background"
                                                              : value.refer_person ===
                                                                  "Child" &&
                                                                value.refer_type ===
                                                                  "from"
                                                              ? "brown-background"
                                                              : value.refer_person ===
                                                                  "Child" &&
                                                                value.refer_type ===
                                                                  "to"
                                                              ? "pink-background"
                                                              : null
                                                          }`}
                                                          key={index}
                                                        >
                                                          <img
                                                            className="person-image"
                                                            src={
                                                              value.refer_person ===
                                                                "Mother" &&
                                                              value.refer_type ===
                                                                "to"
                                                                ? "/mother-outgoing.svg"
                                                                : value.refer_person ===
                                                                    "Mother" &&
                                                                  value.refer_type ===
                                                                    "from"
                                                                ? "/mother-incoming.svg"
                                                                : value.refer_person ===
                                                                    "Child" &&
                                                                  value.refer_type ===
                                                                    "from"
                                                                ? "/child-incoming.svg"
                                                                : value.refer_person ===
                                                                    "Child" &&
                                                                  value.refer_type ===
                                                                    "to"
                                                                ? "/child-outgoing.svg"
                                                                : null
                                                            }
                                                            alt="Person Images"
                                                          />
                                                          <p>
                                                            {value.refer_person}{" "}
                                                            has been referred
                                                            <span>
                                                              {value.refer_type}{" "}
                                                            </span>
                                                            {value.refer_place}{" "}
                                                            hospital for
                                                            {value.refer_person ===
                                                            "Mother"
                                                              ? value.refer_mother_msg
                                                              : value.refer_child_msg}{" "}
                                                            reason
                                                          </p>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                : null}
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  }
                                </>
                              );
                            }
                          )
                        : null}
                    </div>
                  </InfiniteScroll>
                </div>
              </>
            )}
          </div>

          {openPartograph ? (
            <PartographLayout
              openPartograph={openPartograph}
              setOpenPartograph={setOpenPartograph}
              handleClickOpen={openViewPartograph}
            />
          ) : null}
        </>
      )}
    </div>
  );
};

const mapDispatchToProps = {
  addPatientDetail,
};

const mapStateToProps = (state) => ({
  //place_detail: state.placeDetail.placeDetail,
  //configuration: state.configuration.configuration,
});

export default connect(mapStateToProps, mapDispatchToProps)(Report);
